"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _this = void 0;
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var indexOf = [].indexOf || function (item) {
  for (var i = 0, l = _this.length; i < l; i++) {
    if (i in _this && _this[i] === item) return i;
  }
  return -1;
};
angular.module('backstage.controllers.participants').controller('PaxTableCtrl', /* @ngInject */["$route", "$routeParams", "$scope", "$filter", "uiService", "urlService", "eventService", "metadataService", "bulkUpdateService", "modalService", "crudItems", "appScriptService", "paxService", "EMAIL_MODAL_EVENT", function ($route, $routeParams, $scope, $filter, uiService, urlService, eventService, metadataService, bulkUpdateService, modalService, crudItems, appScriptService, paxService, EMAIL_MODAL_EVENT) {
  var event = $scope.event || eventService.decorateScope($routeParams.eventId);
  var eventId = $scope.event.id || $routeParams.eventId;
  var currentRouteDescriptor = $route.current !== null ? $route.current.$$route : null;
  var itemsPerPage = (currentRouteDescriptor.crudOpts !== null ? currentRouteDescriptor.crudOpts.itemsPerPage : undefined) || 25;
  var blueprintController = (currentRouteDescriptor.blueprintMetadata || {}).controller;
  var pageListAppscript = blueprintController.resolvers.crudItems ? blueprintController.resolvers.crudItems.options.appscriptUrl : 'participants/retrieve-page';
  var eventParticipants = crudItems && crudItems.data && crudItems.data.rows ? crudItems.data.rows : [];
  if (_.isArray(eventParticipants)) {
    eventParticipants = {
      list: eventParticipants,
      total: eventParticipants.length
    };
  }
  $scope.data = eventParticipants.list;
  $scope.totalNumRecords = crudItems && crudItems.data && crudItems.data.total_rows ? crudItems.data.total_rows : 0;
  $scope.filters = {};
  var eventMetadata = {
    person: metadataService.getCachedMetadataForType(eventId, 'person')
  };
  var metaData = {
    person: {}
  };
  var rows = $scope.rowCollection = [];
  var paxList = _.compact(eventParticipants.list);

  // populate the cols with metadata data
  _.extend(metaData.person, _.omit(eventMetadata !== null ? eventMetadata.person : null, 'fullname'));
  var cols = $scope.columnCollection = [];
  var buildExpirationColumn = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(collection) {
      var pageChanged,
        pids,
        actdocs,
        _iterator,
        _step,
        _loop,
        _args2 = arguments;
      return _regeneratorRuntime().wrap(function _callee$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            pageChanged = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : false;
            _context2.prev = 1;
            pids = collection.map(function (p) {
              return p._id;
            });
            _context2.next = 5;
            return paxService.getActDocs(eventId, pids);
          case 5:
            actdocs = _context2.sent;
            _iterator = _createForOfIteratorHelper(collection);
            _context2.prev = 7;
            _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop() {
              var pax, actdoc;
              return _regeneratorRuntime().wrap(function _loop$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    pax = _step.value;
                    actdoc = actdocs.find(function (doc) {
                      return doc.pid === pax._id;
                    });
                    if (actdoc) {
                      pax.expired = actdoc.fp_status === 'expired';
                    }
                  case 3:
                  case "end":
                    return _context.stop();
                }
              }, _loop);
            });
            _iterator.s();
          case 10:
            if ((_step = _iterator.n()).done) {
              _context2.next = 14;
              break;
            }
            return _context2.delegateYield(_loop(), "t0", 12);
          case 12:
            _context2.next = 10;
            break;
          case 14:
            _context2.next = 19;
            break;
          case 16:
            _context2.prev = 16;
            _context2.t1 = _context2["catch"](7);
            _iterator.e(_context2.t1);
          case 19:
            _context2.prev = 19;
            _iterator.f();
            return _context2.finish(19);
          case 22:
            _context2.next = 27;
            break;
          case 24:
            _context2.prev = 24;
            _context2.t2 = _context2["catch"](1);
            console.error('[PaxTableCtrl] an error occurred while loading activation documents', _context2.t2.message);
          case 27:
            _context2.prev = 27;
            if (!pageChanged) {
              angular.extend(rows, collection);
            }
            return _context2.finish(27);
          case 30:
          case "end":
            return _context2.stop();
        }
      }, _callee, null, [[1, 24, 27, 30], [7, 16, 19, 22]]);
    }));
    return function buildExpirationColumn(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var rebuildTableColumns = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var _cols, tableDisplayKeys, curtailFullUserName, allBooleanCols, displayedBooleanCols, crudOpts, customColumns;
      return _regeneratorRuntime().wrap(function _callee2$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (metaData !== null ? metaData.person : null) {
              _context3.next = 2;
              break;
            }
            return _context3.abrupt("return");
          case 2:
            _context3.next = 4;
            return buildExpirationColumn(paxList);
          case 4:
            _cols = [];
            tableDisplayKeys = ['fname', 'lname', 'company', 'position'];
            curtailFullUserName = $filter('curtailFullUserName');
            _.keys(metaData.person).forEach(function (key) {
              if (!(indexOf.call(tableDisplayKeys, key) >= 0)) {
                return;
              }
              var _mdField = metaData.person[key];
              if (!_mdField) {
                return;
              }
              var formatFunction = indexOf.call(tableDisplayKeys, key) >= 0 ? function (val) {
                return curtailFullUserName(val);
              } : undefined;
              var cellTemplateUrl = key === 'lname' ? '/api/v1/bstg-template/profile-linked-pax-lname.html' : key === 'fname' ? '/api/v1/bstg-template/profile-linked-pax-fname.html' : '/static/partials/table-cells/basic-formatted-value-cell.html';
              _cols.push({
                // following line ensures field values do not get evaluated as HTML
                isEditable: true,
                isSortable: tableDisplayKeys.indexOf(key) >= 0 ? true : false,
                map: key,
                label: _mdField.label || _mdField.name,
                formatFunction: formatFunction,
                type: key === 'email' ? 'email' : 'text',
                cellTemplateUrl: cellTemplateUrl
              });
            });

            // isInvited + isActivated columns in the table
            allBooleanCols = [{
              eventId: eventId,
              filterKey: 'invited',
              label: 'Invited?',
              map: 'invitedAt',
              isSortable: false,
              cellTemplateUrl: '/api/v1/bstg-template/pax-invitation-status-display-cell.html'
            }, {
              eventId: eventId,
              filterKey: 'activated',
              label: 'Activated?',
              map: 'activatedAt',
              isSortable: false,
              cellTemplateUrl: '/api/v1/bstg-template/pax-activation-status-display-cell.html'
            }];
            displayedBooleanCols = allBooleanCols;
            _cols = _cols.concat(displayedBooleanCols);
            crudOpts = currentRouteDescriptor.crudOpts;
            customColumns = crudOpts !== null ? crudOpts.customColumns : null;
            if (customColumns) {
              _cols.push.apply(_cols, uiService.postProcessCustomColumns(_.flatten([customColumns]), event));
            }
            return _context3.abrupt("return", angular.copy(_cols, cols));
          case 15:
          case "end":
            return _context3.stop();
        }
      }, _callee2);
    }));
    return function rebuildTableColumns() {
      return _ref2.apply(this, arguments);
    };
  }();
  rebuildTableColumns();

  // SmartTable config
  $scope.globalConfig = {
    maxSize: 9,
    numberOfItems: $scope.totalNumRecords,
    itemsByPage: itemsPerPage,
    selectionMode: 'multiple',
    displaySelectionCheckbox: true,
    isGlobalSearchActivated: true,
    serverSidePagination: true,
    serverSidePageGetter: _.partial(appScriptService.callAppScript, pageListAppscript)
  };

  // handle edits to docs/rows in the table
  $scope.$on('updateDataRow', function (__ev, arg) {
    var participant = arg.item;
    var eventCloudNode = $scope.event.node;
    return bulkUpdateService.updateDoc(eventId, eventCloudNode, 'person', participant).then(function () {
      $scope.setFlashMessage('A participant has been updated.');
      return recalculateArrivedPaxCount();
    });
  });
  $scope.$on('pageChanged', /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(event, collection) {
      return _regeneratorRuntime().wrap(function _callee3$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return buildExpirationColumn(collection.items, true);
          case 2:
          case "end":
            return _context4.stop();
        }
      }, _callee3);
    }));
    return function (_x2, _x3) {
      return _ref3.apply(this, arguments);
    };
  }());

  // global search from controllers upper in hierarchy
  $scope.$on('globalSearch', function (event, searchTerm) {
    return $scope.globalConfig.ctrl.search(searchTerm);
  });

  // bulk import/export button render logic
  $scope.getExcelExportRouteLinkHref = function () {
    var crudOpts = currentRouteDescriptor.crudOpts;
    var exportRoutePath = '/participants?format=xlsx';
    var exportPathOverride = crudOpts !== null ? crudOpts.exportPathOverride : null;
    return urlService.getImportExportOverridePath(exportPathOverride || exportRoutePath, event);
  };
  $scope.getExcelImportRouteLinkHref = function () {
    var crudOpts = currentRouteDescriptor.crudOpts;
    var importRoutePath = '/' + currentRouteDescriptor.blueprintMetadata.moduleKey + '/import';
    var importPathOverride = crudOpts !== null ? crudOpts.importPathOverride : null;
    return urlService.getImportExportOverridePath(importPathOverride || importRoutePath, event, '/event/' + eventId);
  };
  var crudOpts = currentRouteDescriptor.crudOpts;
  $scope.customExportRouteLinks = _.chain(crudOpts !== null ? crudOpts.customExportLinks : null).map(function (pathOrDescriptor, label) {
    return [label, urlService.getImportExportOverridePath(pathOrDescriptor, event)];
  }).object().value();
  $scope.openEmailPrompt = function () {
    var detail = {
      users: $scope.rowCollection.filter(function (user) {
        return user.isSelected;
      }),
      event: event
    };
    var customEvent = new CustomEvent(EMAIL_MODAL_EVENT, {
      detail: detail
    });
    window.dispatchEvent(customEvent);
  };

  /* event-specific stuff *groan* */
  var shouldShowArrivedFlagControls = $scope.shouldShowArrivedFlagControls = indexOf.call(Object.keys(metaData.person), 'has_arrived') >= 0;
  var recalculateArrivedPaxCount = $scope.recalculateArrivedPaxCount = function () {
    var hasArrived = _.where(rows, {
      has_arrived: true
    });
    if (!shouldShowArrivedFlagControls) {
      return;
    }
    return $scope.totals.arrived = hasArrived !== null ? hasArrived.length : 0;
  };
  return recalculateArrivedPaxCount();
}]);